export default __webpack_public_path__ + "static/media/assessingEconomicEffectsMethodology.090e36df.pdf";